import React from "react";
import PageBanner from "../components/PageBanner";
import Reveal from "../components/Reveal";
import Seo from "../components/Seo";
import ProgramCard from "../components/financing/ProgramCard";
import { PortfolioColumn, ContactCard } from "../components/financing/FinancingParts";
import {
  FINANCING_INTRO,
  FINANCING_PROGRAMS,
  FINANCING_PORTFOLIO,
  FINANCING_CONTACTS,
  FINANCING_DISCLAIMER,
} from "../mock";

const Financing = () => (
  <div>
    <Seo
      title="Financing Options | Roger Minner, Kennett Square PA Realtor"
      description="Roger Minner Homes helps guide you through various financing and loan options VA Loan, FHA, Bridge Loans, Development Loans, Construction & Renovation loans and more"
    />
    <PageBanner
      eyebrow="More loans. More homes. More happy people."
      title="Financing"
      subtitle={FINANCING_INTRO.subtitle}
      image="https://images.unsplash.com/photo-1505843513577-22bb7d21e455?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80"
    />

    {/* Programs */}
    <section className="bg-[#f6f2ed] py-20 md:py-24">
      <div className="max-w-[1200px] mx-auto px-6">
        <Reveal className="text-center mb-16">
          <h2 className="section-title text-3xl md:text-4xl text-[#3a3736]">Loan Programs</h2>
          <div className="divider-ornament mt-6">
            <span className="line" /><span className="dot" /><span className="line" />
          </div>
        </Reveal>
        <div className="space-y-8">
          {FINANCING_PROGRAMS.map((prog) => (
            <ProgramCard key={prog.id} prog={prog} />
          ))}
        </div>
      </div>
    </section>

    {/* Product portfolio */}
    <section className="bg-[#efe8df] py-20 md:py-24">
      <div className="max-w-[1200px] mx-auto px-6">
        <Reveal className="text-center mb-14">
          <h2 className="section-title text-3xl md:text-4xl text-[#3a3736]">CCM Product Portfolio</h2>
          <p className="font-serif-el italic text-[#6f5f62] text-lg mt-3">
            More loans. More homes. More happy people.
          </p>
        </Reveal>
        <div className="grid md:grid-cols-2 gap-8">
          {FINANCING_PORTFOLIO.map((col) => (
            <PortfolioColumn key={col.heading} col={col} />
          ))}
        </div>
      </div>
    </section>

    {/* Contacts */}
    <section className="bg-[#b6a4a7] py-20">
      <div className="max-w-[1100px] mx-auto px-6">
        <Reveal className="text-center mb-12">
          <h2 className="section-title text-3xl md:text-4xl text-white">Contact</h2>
        </Reveal>
        <div className="grid md:grid-cols-2 gap-8">
          {FINANCING_CONTACTS.map((c) => (
            <ContactCard key={c.name} contact={c} />
          ))}
        </div>
        <p className="font-sans-el text-xs text-white/80 leading-relaxed mt-12 max-w-4xl mx-auto text-center">
          {FINANCING_DISCLAIMER}
        </p>
      </div>
    </section>
  </div>
);

export default Financing;
